import { baseUniDriverFactory } from '../test-utils/utils/unidriver';
import { dataHooks } from './constants';

const createSelector = dataHook => `[data-hook="${dataHook}"]`;

export const ListItemActionDriverFactory = base => {
  const titleSelector = createSelector(dataHooks.title);
  const subtitleSelector = createSelector(dataHooks.subtitle);
  const prefixIconSelector = createSelector(dataHooks.prefixIcon);
  const suffixSelector = createSelector(dataHooks.suffix);
  const suffixIconSelector = createSelector(dataHooks.suffixIcon);

  return {
    ...baseUniDriverFactory(base),

    isTitleExists: async () => base.$(titleSelector).exists(),
    getTitleText: async () => base.$(titleSelector).text(),

    isPrefixIconExists: async () => base.$(prefixIconSelector).exists(),
    isSuffixIconExists: async () => base.$(suffixIconSelector).exists(),

    isSubtitleExists: async () => base.$(subtitleSelector).exists(),
    getSubtitleText: async () => base.$(subtitleSelector).text(),

    isSuffixExists: async () => base.$(suffixSelector).exists(),
    getSuffixText: () => base.$(suffixSelector).text(),

    getSkin: () => base.attr('data-skin'),
    isDisabled: async () => (await base.attr('data-disabled')) === 'true',
  };
};
